<template>
    <div class="spo-card rounded bordered p-2">


        <v-form ref="formCreateLienGroupeInscription">
            <div class="d-flex align-center sm-gap mb-2">
                <v-icon icon="mdi-account-group" color="primary-dark"></v-icon>
                <div class="text-h6 font-weight-bold text-decoration-underline">Informations du groupe</div>
            </div>
            <v-row>
                <v-col md="4" cols="12">
                    <label class="field_label">Nom du groupe <span class="text-red">*</span></label>
                    <v-text-field v-model="lien_groupe.nom" required
                        :rules="[$formRules.required, $formRules.nom_groupe]"></v-text-field>
                </v-col>
                <v-col md="4" cols="12">
                    <label class="field_label">Nom du responsable du groupe</label>
                    <v-text-field v-model="lien_groupe.nom_responsable"></v-text-field>
                </v-col>
                <v-col md="4" cols="12">
                    <label class="field_label">Mail du responsable du groupe</label>
                    <v-text-field v-model="lien_groupe.mail_responsable"></v-text-field>
                </v-col>
            </v-row>
            <div class="d-flex align-center sm-gap mb-2 mt-4">
                <v-icon icon="mdi-lock-alert" color="primary-dark"></v-icon>
                <div class="text-h6 font-weight-bold text-decoration-underline">Limites du lien</div>
            </div>
            <v-row>
                <v-col md="4" cols="12">
                    <label class="field_label">Nombre de participants qui peuvent être inscrit avec ce code<span
                            class="text-red">*</span></label>
                    <div class="text-caption">Laisser à 0 pour aucune limite d'utilisation</div>
                    <v-text-field v-model="lien_groupe.max_inscrits" required type="number"></v-text-field>
                </v-col>
                <v-col md="4" cols="12">
                    <label class="field_label">Date d'expiration <span class="text-red">*</span></label>
                    <div class="text-caption">Par défaut, la date d'expiration est la date de fin d'inscription du
                        module</div>
                    <v-text-field v-model="lien_groupe.date_expiration" type="date"
                        :rules="[dateExpirationRule]"></v-text-field>
                </v-col>
            </v-row>
            <div class="d-flex align-center sm-gap mb-2 mt-4">
                <v-icon icon="mdi-routes" color="primary-dark"></v-icon>
                <div class="text-h6 font-weight-bold text-decoration-underline">Configuration des parcours</div>
            </div>
            <v-row>
                <v-col md="4" cols="12">
                    <label class="field_label">Les parcours seront payant lors de l'inscription ?<span
                            class="text-red">*</span></label>
                    <div class="text-caption">Si non, seront payés par le responsable a posteriori pour tout le groupe
                    </div>
                    <v-select :items="items" v-model="lien_groupe.doit_payer" hide-details item-title="label"
                        item-value="value"></v-select>
                </v-col>
                <v-col md="4" cols="12">
                    <label class="field_label">Peut s'inscrire à des parcours complets ?<span
                            class="text-red">*</span></label>
                    <div class="text-caption">Si oui, les jauges peuvent être dépassées
                    </div>
                    <v-select :items="items" v-model="lien_groupe.inscription_course_complete" hide-details
                        item-title="label" item-value="value"></v-select>
                </v-col>
            </v-row>
            <v-row v-if="availables_parcours.length > 0">
                <v-col cols="12">
                    <label class="field_label">Restreindre les parcours disponibles ?<span
                            class="text-red">*</span></label>
                    <div v-if="lien_groupe.limit_acces_parcours" class="text-caption mb-2">
                        Le lien sera limité aux parcours : <strong>{{ list_filtered_parcours }}</strong>
                    </div>
                    <div v-else class="text-caption mb-2">
                        Aucun parcours coché: Le lien sera valide pour tous les parcours
                    </div>
                    <div class="d-inline-flex justify-start flex-wrap">
                        <v-checkbox class="mr-4" v-for="course in availables_parcours" v-model="course.selected"
                            hide-details density="compact" :label="course.nom" :key="course.id"></v-checkbox>
                    </div>
                </v-col>
            </v-row>
            <div class="d-flex align-center sm-gap mb-2 mt-4">
                <v-icon icon="mdi-tag-plus" color="primary-dark"></v-icon>
                <div class="text-h6 font-weight-bold text-decoration-underline">Configuration des
                    options/activités/boutique</div>
            </div>
            <v-row>
                <v-col md="4" cols="12">
                    <label class="field_label">Les options/activités/boutique seront payant lors de l'inscription ?<span
                            class="text-red">*</span></label>
                    <div class="text-caption">Si non, seront payés par le responsable a posteriori pour tout le groupe
                    </div>
                    <v-select :items="items" v-model="lien_groupe.doit_payer_options" hide-details item-title="label"
                        item-value="value"></v-select>
                </v-col>
                <v-col md="4" cols="12">
                    <label class="field_label">Peut s'inscrire à des options/activités/boutique complets ?<span
                            class="text-red">*</span></label>
                    <div class="text-caption">Si oui, les jauges peuvent être dépassées
                    </div>
                    <v-select :items="items" v-model="lien_groupe.inscriptions_options_completes" hide-details
                        item-title="label" item-value="value"></v-select>
                </v-col>
            </v-row>




        </v-form>
        <div class="d-flex justify-center mt-4">
            <SportipsButton @onClick="validate()" icon="mdi-link" action-button :loading="loading" chevron>Créer le
                lien
                d'inscription de groupe</SportipsButton>
        </div>

        <v-dialog v-model="successDialog.show" max-width="560" max-height="90%" scrollable scroll-strategy="none">
            <v-card>
                <v-card-title class="d-flex align-center ga-2 text-wrap pa-4 pb-2">
                    <v-icon color="success" icon="mdi-check-circle" size="large"></v-icon>
                    <span class="text-h6 font-weight-bold">Lien de groupe créé</span>
                </v-card-title>
                <v-card-text class="pa-4 pt-2">
                    <v-alert type="success" variant="tonal" density="comfortable" class="mb-4 text-body-2">
                        Lien d'inscription de groupe créé avec succès. Communiquez ces liens à votre partenaire ou à
                        votre groupe : il devra suivre la procédure d'inscription depuis le premier lien.
                    </v-alert>
                    <div class="d-flex flex-column ga-4">
                        <div class="spo-success-link-block rounded pa-3 bg-grey-lighten-4">
                            <div class="text-subtitle-2 font-weight-bold text-medium-emphasis mb-2">Lien d'inscription
                            </div>
                            <div class="text-body-2 text-break font-weight-medium">{{ created_link_url }}</div>
                        </div>
                        <div class="spo-success-link-block rounded pa-3 bg-grey-lighten-4">
                            <div class="text-subtitle-2 font-weight-bold text-medium-emphasis mb-2">Lien de suivi du
                                groupe</div>
                            <div class="text-body-2 text-break font-weight-medium">{{ created_link_suivi_url }}</div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions class="pa-4 pt-0">
                    <v-spacer></v-spacer>
                    <v-btn color="primary-dark" variant="flat" @click="closeSuccessDialog">Fermer</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import AdminService from "@/services/admin.service";
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import moment from "moment";
export default {
    data() {
        return {
            valid: false,
            loading: false,
            lien_groupe: {
                nom: "",
                nom_responsable: "",
                max_inscrits: 0,
                doit_payer: true,
                inscription_course_complete: false,
                date_expiration: "",
                type_paiement: "en_ligne",
                limit_acces_parcours: false,
                filter_parcours: "",
                doit_payer_options: true,
                inscriptions_options_completes: false,
            },
            items: [
                { label: 'Oui', value: true },
                { label: 'Non', value: false },
            ],

            availables_parcours: [],
            created_link: null,
            successDialog: {
                show: false,
            },
        };
    },
    watch: {
        'successDialog.show'(open) {
            if (!open) {
                this.created_link = null;
            }
        },
        availables_parcours: {
            handler(val) {
                const selected = val.filter(c => c.selected);
                this.lien_groupe.limit_acces_parcours = selected.length > 0;
                this.lien_groupe.filter_parcours = selected.map(c => c.id).join(',');
            },
            deep: true,
        },
    },
    computed: {
        ...mapStores(useMainStore),
        created_link_url() {
            if (!this.created_link) return "";
            let domain = window.location.hostname;
            let base_url = "https://" + domain;
            return base_url + "/inscription/" + this.mainStore.module.base + "?groupe=" + this.created_link.token;
        },
        created_link_suivi_url() {
            if (!this.created_link) return "";
            let domain = window.location.hostname;
            let base_url = "https://" + domain;
            return base_url + "/inscription/" + this.mainStore.module.base + "/suivi-lien-groupe/" + this.created_link.token;
        },
        list_filtered_parcours() {
            return this.availables_parcours
                .filter(c => c.selected)
                .map(c => c.nom)
                .join(", ");
        },
    },
    methods: {
        dateExpirationRule(v) {
            if (!v) return "La date d'expiration est obligatoire";
            return moment(v).isAfter(moment(), 'day') || "La date d'expiration doit être supérieure à la date du jour";
        },
        build_available_parcours(courses) {
            this.availables_parcours = courses.map(course => ({
                id: course.id,
                nom: course.nom,
                selected: false,
            }));
        },
        async validate() {
            this.loading = true;
            let res = await this.$refs.formCreateLienGroupeInscription.validate();
            if (res.valid) {
                let request = await AdminService.createLienGroupe(this.lien_groupe, this.mainStore.module.id);
                if (request) {
                    this.created_link = request;
                    this.successDialog.show = true;
                    this.$emit("onCreate");
                    this.clearForm();
                }
            }
            this.loading = false;
        },
        closeSuccessDialog() {
            this.successDialog.show = false;
        },
        clearForm() {
            this.lien_groupe = {
                nom: "",
                nom_responsable: "",
                max_inscrits: 0,
                doit_payer: true,
                inscription_course_complete: true,
                date_expiration: this.mainStore.module.date_fin_inscription,
                type_paiement: "en_ligne",
                limit_acces_parcours: false,
                filter_parcours: "",
                doit_payer_options: true,
                inscriptions_options_completes: true,
            };
            this.availables_parcours.forEach(c => { c.selected = false; });
        },
    },
    async created() {
        this.lien_groupe.date_expiration = this.mainStore.module.date_fin_inscription;
        let courses = this.mainStore.module.courses.list;
        if (!courses || courses.length === 0) {
            courses = await AdminService.getCourses(this.mainStore.module.id) || [];
        }
        this.build_available_parcours(courses);
    },
}
</script>

<style lang="scss" scoped></style>
